import { parsePhoneNumber, CountryCode } from "libphonenumber-js";
import { getCountries } from "react-phone-number-input";

const isValidCountryCode = (country: string): country is CountryCode => {
	const countryCodes = getCountries();
	return countryCodes.includes(country as CountryCode);
};

export const formatPhoneNumber = (number: string, country: string) => {
	if (isValidCountryCode(country)) {
		try {
			const parsedNumber = parsePhoneNumber(number, country as CountryCode);
			if (parsedNumber) {
				if (parsedNumber.country === "US") return parsedNumber.formatNational();
				else return parsedNumber.formatInternational();
			}
		} catch {
			//swallow it
			return number;
		}
	}
	return number;
};
